import React, { useState, useEffect } from 'react'
import DeckGL, { FlyToInterpolator } from 'deck.gl'

import TextField from '@material-ui/core/TextField'
import DeleteIcon from '@material-ui/icons/Delete'
import { makeStyles } from '@material-ui/core/styles'
import Alert from '@material-ui/lab/Alert'
import Collapse from '@material-ui/core/Collapse'
import Button from '@material-ui/core/Button'
import Grow from '@material-ui/core/Grow'

import RoomIcon from '@material-ui/icons/Room'
import SearchIcon from '@material-ui/icons/Search'
// import { searchMun } from '../../data/LayerDataApi'
// // import {LayerContext} from '../../../data/AppContext'

// import SearchBtn from '../../../../assets/map.png'
// import LogoCoordinates from '../../../../assets/coordinates.png'

import './coordinates.css'

const useStyles = makeStyles((theme) => ({
  txtContainer: {
    '& label.Mui-focused': {
      color: '#a65e44',
      fontSize: '14px !important',
    },
    '& .MuiOutlinedInput-root': {
      height: '40px !important',
      '&:hover fieldset': {
        borderColor: '#a65e44',
        fontSize: '14px !important',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#a65e44',
        fontSize: '14px !important',
      },
    },
    '& .MuiInputLabel-formControl': {
      top: '-7px !important',
    },
    width: '250px',
    height: '50px !important',
  },
  txtContainerClick: {
    '& label.Mui-focused': {
      color: '#797979',
      fontSize: '14px !important',
    },
    '& .MuiOutlinedInput-root': {
      height: '40px !important',
      background: '#eaeaea',
      color: '#797979',
      '&:hover fieldset': {
        borderColor: '#a65e44',
        fontSize: '14px !important',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#a65e44',
        fontSize: '14px !important',
      },
    },
    '& .MuiInputLabel-formControl': {
      top: '-7px !important',
    },
    width: '250px',
    height: '50px !important',
  },
  circle: {
    color: '#000000',
    opacity: '0.54',
    height: '24px !important',
    width: '24px !important',
    marginLeft: '13px',
    marginTop: '12px',
  },
}))

function Search(props) {
  const classes = useStyles()
  const [alerta, setAlerta] = useState(false)
  const [latitude, setLatitude] = useState(0)
  const [longitude, setLongitude] = useState(0)

  useEffect(() => {
    document.getElementById('manual-txt').value = ''
  }, [props.menu[3].view])

  const manualSearch = () => {
    const txt = document.getElementById('manual-txt').value
    if (txt.trim() != '') {
      if (latitude > -90 && latitude < 90 && longitude > -180 && longitude < 180) {
        props.manualPoint([longitude, latitude])
        props.viewState({
          longitude: longitude,
          latitude: latitude,
          zoom: 15,
          pitch: 0,
          bearing: 0,
          transitionDuration: 4000,
          transitionInterpolator: new FlyToInterpolator(),
        })
      } else {
        setAlerta(true)
        setTimeout(() => setAlerta(false), 3000)
      }
    }

    if (txt.trim() === '') {
      props.delete()
      props.coordinates('txt')
      props.setShowClick('none')
      props.setShowManual('flex')
    }
  }

  const reset = () => {
    document.getElementById('manual-txt').value = ''
    props.delete()
    //props.coordinates('click')
    // props.setShowClick('flex')
    // props.setShowManual('none')
  }

  const searchClick = () => {
    document.getElementById('manual-txt').value = ''
    props.delete()
    props.setShowClick('flex')
    props.setShowManual('none')
    props.coordinates('click')
  }

  const onChanges = (e) => {
    if (e.target.value.includes(',')) {
      setLatitude(parseFloat(e.target.value.split(',')[0]))
      setLongitude(parseFloat(e.target.value.split(',')[1]))
    }
  }

  return (
    <div>
      <Grow in={props.menu[3].view}>
        <div className="search-container">
          <div className="search-title-container">
            <label className="search-btn-select">Coordinate Search Tool</label>
            <RoomIcon style={{ display: `${props.showClick}` }} />
            <SearchIcon style={{ display: `${props.showManual}` }} />
          </div>

          <div className="search-input">
            <div className="coordinates-input-container" style={{ display: `${props.showManual}`, width: '350px' }}>
              {/*<TextField
                className={classes.txtContainer}
                onChange={onChangeLat}
                id="txt-lat"
                placeholder="Latitude"
                variant="outlined"
              />
              <TextField
                className={classes.txtContainer}
                onChange={onChangeLon}
                style={{ marginLeft: '5px' }}
                id="txt-lon"
                placeholder="Longitude"
                variant="outlined"
              />*/}
              <TextField
                style={{ margin: 'auto' }}
                className={classes.txtContainer}
                onChange={onChanges}
                id="manual-txt"
                placeholder="Lat° , Lon°"
                variant="outlined"
              />
            </div>
            <div className="coordinates-input-container" style={{ display: `${props.showClick}`, width: '350px' }}>
              {/*<TextField
                style={{ pointerEvents: 'none' }}
                className={classes.txtContainerClick}
                onChange={onChangeLat}
                id="outlined-basic"
                placeholder="Latitude"
                variant="outlined"
                value={props.coordinateslbl.lat}
              />
              <TextField
                className={classes.txtContainerClick}
                onChange={onChangeLon}
                style={{ marginLeft: '5px', pointerEvents: 'none' }}
                id="outlined-basic"
                placeholder="Longitude"
                variant="outlined"
                value={props.coordinateslbl.lon}
              />*/}
              <TextField
                style={{ margin: 'auto' }}
                className={classes.txtContainerClick}
                disabled={true}
                id="outlined-basic"
                variant="outlined"
                value={props.coordinateslbl.lat + '  ' + props.coordinateslbl.lon}
              />
            </div>
          </div>

          <div className="coord-btn-container">
            <Button
              variant="contained"
              color="default"
              //className={classes.button}
              size="small"
              startIcon={<DeleteIcon />}
              style={{ height: '30px', margin: 'auto' }}
              onClick={() => reset()}
            >
              Delete
            </Button>

            <Button
              variant="contained"
              color="default"
              //className={classes.button}
              size="small"
              startIcon={<RoomIcon />}
              style={{ height: '30px', margin: 'auto' }}
              onClick={() => searchClick()}
            >
              Click
            </Button>

            <Button
              variant="contained"
              color="default"
              //className={classes.button}
              size="small"
              startIcon={<SearchIcon />}
              style={{ height: '30px', margin: 'auto' }}
              onClick={() => manualSearch()}
            >
              Search
            </Button>
          </div>

          <Collapse in={alerta}>
            <Alert severity="error" style={{ zIndex: '10' }}>
              Invalid Coordinates
            </Alert>
          </Collapse>
        </div>
      </Grow>
    </div>
  )
}

export default Search
